import { GetStaticProps, NextPage } from 'next'
import { AppProps } from 'next/app'

import { initializeApollo } from '../lib/apolloClient'
import globalCache from '../lib/globalCache'
import { HeaderColors } from '../components/types'
import { useContext } from 'react'
import { WishlistContext } from '../contexts/wishlist'
import MaxWidth from '../components/layout/MaxWidth/MaxWidth'
import List from '../components/catalog/Section/List'
import { createCatalogElement } from '../lib/createCatalogItem'
import PersonalInnerNav from '../components/layout/Header/InnerNav/PersonalInnerNav'
import LoaderWrapper from '../components/common/Loader/LoaderWrapper'
import { createPageSeo, getPageSeo } from '../lib/createPageSeo'
import { elements_elements_edges_node } from '../__generated__/elements'
import style from '../components/catalog/Section/List.module.scss'

const CatalogSectionPage: NextPage<AppProps> = () => {
  const {
    elements: elementsData,
    elementsLoading,
    inited,
    wishlist,
    randomElements,
  } = useContext(WishlistContext)

  const elements = !elementsData?.edges?.length
    ? randomElements?.map((el) =>
        createCatalogElement(el as elements_elements_edges_node),
      )
    : elementsData?.edges?.map((edge) => createCatalogElement(edge.node))

  return (
    <>
      <PersonalInnerNav />
      <MaxWidth>
        {!inited || (inited && elementsLoading) ? (
          <LoaderWrapper />
        ) : (
          <>
            {elements?.length > 0 ? (
              <List
                count={
                  elementsData?.edges?.length
                    ? Object.keys(wishlist).length
                    : undefined
                }
                name="Избранное"
                description={
                  !elementsData?.edges?.length
                    ? 'Пока Ваше избранное пусто, возможно вас заитересуют следующие товары или товары из нашего каталога'
                    : undefined
                }
                elements={elements}
                loading={elementsLoading || !inited}
                hasNextPage={elements?.length < (elementsData?.count || 0)}
              />
            ) : (
              <div className={style.noResults}>
                <p>Нет избранных товаров</p>
              </div>
            )}
          </>
        )}
      </MaxWidth>
    </>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  const apolloClient = initializeApollo()
  await globalCache(apolloClient)

  let seo

  const seoData = await getPageSeo(apolloClient, 'favorites')

  if (seoData?.data?.element) {
    seo = createPageSeo(seoData.data)
  }

  return {
    props: {
      __APOLLO_STATE__: apolloClient.cache.extract(),
      headerInitColor: HeaderColors.white,
      showInnerNav: false,
      seo,
    },
    revalidate: 60,
  }
}

export default CatalogSectionPage
